import React, { useState, useEffect } from 'react'
import { Layout, Flex, Select, Pagination } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import axios from 'axios';
import { REQUEST_URL } from '../../utils/env';

const { Header, Footer, Content } = Layout;

export default function Kycg() {

    const [searchInfo, setSearchInfo] = useState({ 'types': null, 'desc': null, 'offset': 0, 'limit': 20 })
    const [total, setTotal] = useState(0)

    const [yjcg, setYjcg] = useState()
    const getYJCG = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/info/getYJCG',
                { params: searchInfo }
            )
            setYjcg(data)
            setTotal(data.total)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [hotYjcg, setHotYjcg] = useState()
    const getHotYJCG = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/info/getHotYJCG',
            )
            setHotYjcg(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const onPaginationChange = (pagination, filters, sorter, extra) => {
        setSearchInfo({ ...searchInfo, 'offset': (pagination - 1) * filters })
    };

    const typeChange = (value) => {
        setSearchInfo({ ...searchInfo, types: value })
    }

    const descChange = (value) => {
        setSearchInfo({ ...searchInfo, desc: value })
    }

    useEffect(() => {
        getYJCG()
        getHotYJCG()
    }, [searchInfo])

    return (
        <Layout className={style.kycg}>
            <Header className={style.kycg__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.kycg__wapper}>
                <Flex vertical={true} className={style.kycg__wapper__one} align='center'>
                    <Flex className={style.kycg__wapper__one__title}>学术研究成果</Flex>
                    <Flex className={style.kycg__wapper__one__info}>焦出科技期刊发展的重点任务，汇聚高水平专家，持续发布最新研究成果</Flex>
                </Flex>
                <Flex vertical={false} align='start' className={style.kycg__wapper__two}>
                    <Flex vertical={true} className={style.kycg__wapper__two__left}>
                        <Flex justify='space-between' className={style.kycg__wapper__two__left__title} >
                            <Flex className={style.kycg__wapper__two__left__title__left}>
                                学术研究成果（共{total}篇）
                            </Flex>
                            <Flex className={style.kycg__wapper__two__left__title__right} align='center'>
                                <Select defaultValue="全部类型" style={{ width: 100, marginRight: 16, height: 24 }}
                                    onChange={(value) => typeChange(value)}
                                    options={[{ value: '全部类型', label: '全部类型', },
                                    { value: '论文', label: '论文', },
                                    { value: '专利', label: '专利', },]}
                                />
                                <Select defaultValue="时间排序" style={{ width: 100, height: 24 }}
                                    onChange={(value) => descChange(value)}
                                    options={[{ value: '时间排序', label: '时间排序', },
                                    { value: 'ASC', label: '升序', },
                                    { value: 'DESC', label: '降序', },]}
                                />
                            </Flex>
                        </Flex>

                        {yjcg !== undefined && yjcg.data.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' href={(item.isUp === '是') ? `./detail?show=yjcg&id=${item.id}` : REQUEST_URL + `/stat/statCount?module=yjcg&id=${item.id}&url=${item.url}`}>{item.title}</a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.authors.join('，')}</Flex>
                                </Flex>
                            )
                        })}
                        <Flex className={style.kycg__wapper__two__left__pag} justify='center' align='center'>
                            <Pagination align="center" onChange={onPaginationChange} pageSize={20} showSizeChanger={false} defaultCurrent={1} total={total} />
                        </Flex>
                    </Flex>
                    {(hotYjcg !== undefined) && <Flex vertical={true} className={style.kycg__wapper__two__right}>
                        <Flex className={style.kycg__wapper__two__right__title}>热门成果</Flex>
                        <Flex vertical={true} className={style.kycg__wapper__two__right__items}>
                            {hotYjcg.data.map((item, index) => {
                                return (
                                    <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                        <Flex className={style.kycg__wapper__two__right__item__title}>
                                            <a target='_blank' href={(item.isUp === '是') ? `./detail?show=yjcg&id=${item.id}` : REQUEST_URL + `/stat/statCount?module=yjcg&id=${item.id}&url=${item.url}`}>{item.title}</a>
                                        </Flex>
                                        <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                            {item.pub_date}
                                        </Flex>
                                    </Flex>
                                )
                            })}

                            {/* <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>UPLOpen.com：改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>PLOS发布2018-2023开放科学指标数据</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>PLOS发布2018-2023开放科学指标数据</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex> */}
                        </Flex>
                    </Flex>}
                </Flex>
            </Content>
            <Footer className={style.kycg__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    )
}
